/**
 * External dependencies
 */
import { combineReducers } from 'redux';

import items from './items';
import edits from './edits';

export default combineReducers({
	items,
	edits,
});